import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';

Sentry.init({
  dsn: 'https://f99f0ba406c047ab85c79a745e50a366@glitchtip.neofluxsystems.net/1',
  release: '2.0.0',
  environment: process.env.NODE_ENV || 'production',
  tracesSampleRate: 0.05,
  autoSessionTracking: false,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
});
import Login from './pages/Login';
import NewDashboard from './pages/NewDashboard';
import BikeDashboard from './pages/BikeDashboard';
import HomePage from './pages/HomePage';
import ProfiloPage from './pages/ProfiloPage';
import CambiaPasswordPage from './pages/CambiaPasswordPage';
import MarketingPage from './pages/MarketingPage';
import LayoutWrapper from './components/LayoutWrapper';
import HomeRedirect from './components/HomeRedirect';

// Creiamo il router con la configurazione completa delle rotte
const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <App />,
      children: [
        {
          path: '',
          element: <HomeRedirect />
        },
        {
          path: 'home',
          element: <HomePage />
        },
        {
          path: 'login',
          element: <Login />
        },
        {
          path: 'profilo',
          element: (
            <LayoutWrapper>
              <ProfiloPage />
            </LayoutWrapper>
          )
        },
        {
          path: 'cambia-password',
          element: (
            <LayoutWrapper>
              <CambiaPasswordPage />
            </LayoutWrapper>
          )
        },



        {
          path: 'nlt/*',
          element: <NewDashboard />
        },
        {
          path: 'bike/*',
          element: <BikeDashboard />
        },
        {
          path: '*',
          element: <NewDashboard />
        },
        // RIMUOVO la route 'nlt/tutorial' da qui
      ]
    }
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }
  }
);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Si è verificato un errore. Ricarica la pagina.</p>}>
      <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
